import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ResolutionService } from '../resolution.service';
import { OrderService } from "../order.service";
import { SignalsStoreService } from "../signals-store.service";
import { ModalContentService } from '../modal-content/modal-content.service';
import { ModalContentTypes } from '../constants/modal-content-types';

@Component({
  selector: 'app-mobile-footer-menu',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './mobile-footer-menu.component.html',
  styleUrl: './mobile-footer-menu.component.scss'
})
export class MobileFooterMenuComponent {
  signalsStoreService = inject(SignalsStoreService);
  private orderService = inject(OrderService);
  private resolutionService = inject(ResolutionService);
  private modalContentService = inject(ModalContentService);
  isMobile = computed(() => this.resolutionService.isMobile());
  orderProductsQuantity = computed(() => this.getOrderProductsQuantity());

  shouldDisplayPendingChangesAlert = computed(() => this.hasPendingChanges() && !this.isInCustomBoxComponent() && !this.isInOrderComponent())
  hasPendingChanges = computed(() => this.#setUpHasPendingChanges())
  isInCustomBoxComponent = computed(() => this.signalsStoreService.getIsInCustomBoxComponent())
  isInOrderComponent = computed(() => this.signalsStoreService.isInOrderComponent())

  getOrderProductsQuantity() {
    const odooOrder = this.orderService.odooOrder();
    const allProducts = [
      ...(odooOrder?.products?.common ?? []),
      ...(odooOrder?.products?.subscription?.length ? odooOrder?.products?.subscription.map((e: any) => {
        return {
          ...e,
          _isSub: true
        }
      }) : []),
    ];

    if (odooOrder?.isSkipped) return 0;

    return new Set(allProducts.map((product: any) => {
      const variantId = product.variant.id;
      const packageId = product.package?.id || null;
      const id = `${variantId}${packageId ? `_${packageId}` : ''}`;
      if (product._isSub) return `${id}_sub`;
      return id
    })).size;
  }

  #setUpHasPendingChanges() {
    const odooOrder = this.orderService.odooOrder();
    const firebaseOrder = this.signalsStoreService.firebaseOrder();

    if (odooOrder?.isSkipped) return false;

    return (!!(firebaseOrder?.products?.common ?? []).length || !!(firebaseOrder?.products?.subscription ?? []).length)
  }

  openModalBundles() {
    this.modalContentService
      .openModal(
        ModalContentTypes.BUNDLES_SUBSCRIPTION,
        {
          title: 'Your FarmBoxes'
        }
      );
  }
}
